import { render, staticRenderFns } from "./BlauTitle.vue?vue&type=template&id=befa5bba&lang=pug&"
import script from "./BlauTitle.vue?vue&type=script&lang=js&"
export * from "./BlauTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports